import React from 'react';
import styled from 'styled-components';

// Components //
const Root = styled.div`
  position: absolute;
  right: 24px;
  top: 0;
  bottom: 0;
  @media screen and (max-width: 892px) {
    display:none;
  }
`;

const ArtFlair = styled.img`
  width: 720px;
  position: absolute;
  top: 29%;
  right: -160px;
  bottom: 0;
  transform: translate3d(0%, -50%, 0);
  z-index: 0;
  transition: .6s transform ${ ({ theme }) => theme.easing.default };

  ${ Root }:hover & {
    transform: translate3d(0%, -50%, 0) scale(1.1);
  }
`;

const SidenavChat = styled.img`
  position: absolute;
  top: 29%;
  right: 64px;
  width: 576px;
  z-index: 1;
  transform: translate3d(0%, -50%, 0);
  transition: .6s transform ${ ({ theme }) => theme.easing.default };
  ${ Root }:hover & {
    transform: translate3d(-72px, -50%, 0) scale(1.1) rotate(-4deg);
  }
`;

const MemberChat = styled.img`
  position: absolute;
  top: calc(29% + 24px);
  bottom: 0;
  right: 40px;
  width: 426px;
  z-index: 2;
  transform: translate3d(0%, -50%, 0);
  transition: .6s transform ${ ({ theme }) => theme.easing.default };
  ${ Root }:hover & {
    transform: translate3d(40px, calc(-50% + 16px), 0) scale(1.1) rotate(4deg);
  }
`;

const WelcomeIllustration = () => {
  return (
    <Root>
      <ArtFlair src={'//getstream.imgix.net/images/chat/art_flair.png?auto=format,enhance'} />
      <SidenavChat src={'//getstream.imgix.net/images/chat/sidenav_conversation.png?auto=format,enhance'} />
      <MemberChat src={'//getstream.imgix.net/images/chat/member_chat.png?auto=format,enhance'} />
    </Root>
  );
}

WelcomeIllustration.propTypes = {

};

export default WelcomeIllustration;
